import React from 'react';

import { storiesOf } from '@storybook/react';
import { AllCasesView } from './AllCasesView';

storiesOf('Case Menu/All Cases', module)
  .add('Showing All', () => (
    <div>
      <h3> All Cases view wth data </h3>
      <hr />
      <AllCasesView
        cases={allData}
        case_uuid=""
      />
    </div>
  ))
  .add('Showing Only Associate', () => (
    <div>
      <h3> All Cases view wth data </h3>
      <hr />
      <AllCasesView
        cases={associateData}
        case_uuid=""
      />
    </div>
  ))
  .add('Showing Only Related', () => (
    <div>
      <h3> All Cases view wth data </h3>
      <hr />
      <AllCasesView
        cases={relatedData}
        case_uuid=""
      />
    </div>
  ))
  .add('Showing Only Other Filings', () => (
    <div>
      <h3> All Cases view wth data </h3>
      <hr />
      <AllCasesView
        cases={otherData}
        case_uuid=""
      />
    </div>
  ))
  .add('Showing Only Associate and Others', () => (
    <div>
      <h3> All Cases view wth data </h3>
      <hr />
      <AllCasesView
        cases={associateOtherData}
        case_uuid=""
      />
    </div>
  ))
  .add('Showing Only Associate and Related', () => (
    <div>
      <h3> All Cases view wth data </h3>
      <hr />
      <AllCasesView
        cases={associateRelatedData}
        case_uuid=""
      />
    </div>
  ))
  .add('Showing Only Related and Others', () => (
    <div>
      <h3> All Cases view wth data </h3>
      <hr />
      <AllCasesView
        cases={relatedOtherData}
        case_uuid=""
      />
    </div>
  ))
  .add('No data', () => (
    <div>
      <h3> All Cases with no data</h3>
      <hr />
      <AllCasesView
        cases={allEmpty1}
        case_uuid=""
      />
    </div>
  ))
  .add('Data with Empty keys', () => (
    <div>
      <h3>All Cases Empty messages</h3>
      <hr />
      <AllCasesView
        cases={allEmpty2}
        case_uuid=""
      />
    </div>
  ));


const associatedCases = {
  data: {
    associated_cases: [
      {
        associated_case: {
          case_code: '05-06235-fra',
          case_id: '190584',
          case_name: 'Sticka v. Allied Building Products Corp',
          case_type: 'Adversary',
          case_uri: 'https://ecf.orb.uscourts.gov/cgi-bin/DktRpt.pl?190584',
          case_uuid: 'orbke_190584',
        },
        case: {
          case_code: '04-63199-fra7',
          case_id: '154519',
          case_name: 'A & B Davis, Inc',
          case_title: 'A & B Davis, Inc',
          case_uri: 'https://ecf.orb.uscourts.gov/cgi-bin/DktRpt.pl?154519',
          case_uuid: 'orbke_154519',
          end_date: null,
        },
      },
      {
        associated_case: {
          case_code: '05-06244-fra',
          case_id: '191104',
          case_name: 'Sticka v. Custom Bilt Metals Inc.',
          case_type: 'Adversary',
          case_uri: 'https://ecf.orb.uscourts.gov/cgi-bin/DktRpt.pl?191104',
          case_uuid: 'orbke_191104',
        },
        case: {
          case_code: '04-63199-fra7',
          case_id: '154519',
          case_name: 'A & B Davis, Inc',
          case_title: 'A & B Davis, Inc',
          case_uri: 'https://ecf.orb.uscourts.gov/cgi-bin/DktRpt.pl?154519',
          case_uuid: 'orbke_154519',
          end_date: null,
        },
      },
    ],
  },
};

const associatedCasesEmpty = {
  data: {
    associated_cases: {
      empty: 'There are no associateds cases. ',
    },
  },
};

const relatedCasesData = {
  data: {
    related_cases_district: [
      {
        case_uuid: 'nyebke_42023-111',
        case_title: 'S.E.C. v. Walsh',
        case_no: '1:02-cv-09921',
        end_date: '05/24/2005',
        start_date: '05/24/2004',
      },
      {
        case_uuid: 'nyebke_283201',
        case_title: 'Securities and Exchange Commission v. Tyco International Ltd.',
        case_no: '1:06-cv-02942',
        end_date: '',
        start_date: '07/20/2004',
      },
      {
        case_uuid: 'nyebke_296957',
        case_title: 'United States Securities and Exchange Commission v. Power et al',
        case_no: '1:06-cv-15343',
        end_date: '',
        start_date: '09/29/2004',
      },
    ],
  },
};

const relatedCasesEmpty = {
  data: {
    related_cases_district: {
      empty: 'There are no related cases.',
    },
  },
};

const otherFilings = {
  data: {
    other_filings: [
      {
        case: {
          case_code: '15-32192-rld7',
          case_id: '465340',
          case_name: 'Jamie Lynn Smith and Billy Ruben Smith',
          case_uri: 'https://ecf.orb.uscourts.gov/cgi-bin/DktRpt.pl?465340',
          case_uuid: 'orbke_465340',
        },
        debtor: {
          name: 'Billy Ruben Smith',
        },
      },
      {
        case: {
          case_code: '15-32192-rld7',
          case_id: '465340',
          case_name: 'Jamie Lynn Smith and Billy Ruben Smith',
          case_title: 'Jamie Lynn Smith and Billy Ruben Smith',
          case_uri: 'https://ecf.orb.uscourts.gov/cgi-bin/DktRpt.pl?465340',
          case_uuid: 'orbke_465340',
        },
        debtor: {
          name: 'Jamie Lynn Smith',
        },
      },
    ],
  },
};

const otherFilingsEmpty = {
  data: {
    other_filings: {
      empty: 'There Are No Case Filing Associations For This Case. ',
    },
  },
};

const allData = [
  ['associated_cases', associatedCases.data.associated_cases],
  ['related_cases_district', relatedCasesData.data.related_cases_district],
  ['other_filings', otherFilings.data.other_filings],
];

const associateData = [
  ['associated_cases', associatedCases.data.associated_cases],
  [],
  [],
];

const relatedData = [
  [],
  ['related_cases_district', relatedCasesData.data.related_cases_district],
  [],
];

const otherData = [
  [],
  [],
  ['other_filings', otherFilings.data.other_filings],
];

const associateOtherData = [
  ['associated_cases', associatedCases.data.associated_cases],
  [],
  ['other_filings', otherFilings.data.other_filings],
];

const associateRelatedData = [
  ['associated_cases', associatedCases.data.associated_cases],
  ['related_cases_district', relatedCasesData.data.related_cases_district],
  [],
];

const relatedOtherData = [
  [],
  ['related_cases_district', relatedCasesData.data.related_cases_district],
  ['other_filings', otherFilings.data.other_filings],
];

const allEmpty1 = [
  [],
  [],
  [],
];

const allEmpty2 = [
  ['associated_cases', associatedCasesEmpty.data.associated_cases],
  ['related_cases_district', relatedCasesEmpty.data.related_cases_district],
  ['other_filings', otherFilingsEmpty.data.other_filings],
];



/** WEBPACK FOOTER **
 ** ./src/components/case/associated_cases/AllCasesView.stories.jsx
 **/